import { MenuProps } from 'antd';
import { NotificationContentProps } from '../../components/SettingsItem/NotificationItem';

const useSettings = () => {
  type MenuItem = Required<MenuProps>['items'][number];

  function getMenuItem(
    label?: React.ReactNode,
    key?: React.Key | null,
    icon?: React.ReactNode,
    children?: MenuItem[],
    type?: 'group'
  ): MenuItem {
    return {
      key,
      icon,
      children,
      label,
      type
    } as unknown as MenuItem;
  }

  function getDivider(): MenuItem {
    return {
      type: 'divider'
    } as unknown as MenuItem;
  }

  function defaultChannelOptions(
    idPrefix: string,
    channels: string[],
    onChange: React.ChangeEventHandler<HTMLInputElement>
  ): NotificationContentProps[] {
    return channels.map(
      (channel) =>
        ({
          name: `${idPrefix}.${channel}`,
          checked: false, // ! Alterar dps
          id: `${idPrefix}.${channel}`,
          label: `${channel.charAt(0).toLocaleUpperCase()}${channel
            .substring(1)
            .toLocaleLowerCase()}`,
          onChange,
          value: `${idPrefix}.${channel}`
        } as NotificationContentProps)
    );
  }

  return { getMenuItem, getDivider, defaultChannelOptions };
};

export default useSettings;
